var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#279AF1",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.54 7.796c-.504-.252-1.007-.126-1.51.252l-1.385 1.258h-.125l-2.014-1.762c-.629-.503-1.258-.503-1.887 0l-2.013 1.762h-.126l-2.013-1.762c-.629-.503-1.258-.503-1.887 0l-2.013 1.762h-.126l-1.384-1.258c-.629-.504-1.51-.504-2.013.126-.252.251-.377.503-.377.88v21.767c0 .88.629 1.51 1.51 1.51.377 0 .754-.126 1.006-.378l1.384-1.258h.126l2.013 1.761c.629.503 1.384.503 1.887 0l2.013-1.761 2.013 1.761c.63.503 1.258.503 1.887 0l2.014-1.761h.125l1.384 1.258c.63.503 1.384.503 2.013-.126l.126-.126c.252-.251.252-.503.252-.88V9.054c0-.503-.252-1.006-.88-1.258zm-.756 22.27c0 .126 0 .126 0 0 0 .126-.125.126 0 0l-1.132-.881-.126-.126c-.629-.377-1.258-.377-1.887 0l-2.013 2.013-2.013-1.761c-.63-.503-1.258-.503-1.888 0l-2.138 1.761h-.126l-2.013-1.761c-.504-.503-1.384-.503-1.888 0l-1.132 1.006h-.126V9.935h.126l1.132.88.126.127c.63.503 1.258.377 1.887 0l2.014-1.762h.125l2.013 1.761c.63.504 1.259.504 1.888 0l2.013-1.76h.126l2.013 1.76c.503.504 1.258.504 1.887 0l1.132-1.006h.126v20.13h-.126z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.016 19.12H14.944c-.503 0-.88.377-.88.88s.377 1.006.88 1.006h11.198c.503 0 .88-.377.88-.88-.125-.504-.502-1.007-1.006-1.007zM14.944 17.358h5.914c.503 0 .755-.377.755-.88 0-.504-.378-.755-.755-.755h-6.04c-.125 0-.251 0-.377.125-.252.126-.377.378-.377.504 0 .503.377 1.006.88 1.006zM26.016 22.643H14.944c-.503 0-.88.377-.88.755 0 .377.377.88.88.88h11.198c.503 0 .88-.377.88-.88-.125-.252-.502-.755-1.006-.755z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.8881973666fcf0e2a09bfe94cf24ef80.svg";
export { ForwardRef as ReactComponent };